// 1. 解析WAV文件头
function parseWavHeader(arrayBuffer) {
	const view = new DataView(arrayBuffer);

	const format = view.getUint16(20, true); // 音频格式，1表示PCM
	const numChannels = view.getUint16(22, true); // 声道数，1表示单声道，2表示双声道
	const sampleRate = view.getUint32(24, true); // 采样率
	const byteRate = view.getUint32(28, true); // 字节率
	const blockAlign = view.getUint16(32, true); // 块对齐
	const bitsPerSample = view.getUint16(34, true); // 每个样本的位数

	return {
		format,
		numChannels,
		sampleRate,
		byteRate,
		blockAlign,
		bitsPerSample,
	};
}

// 2. 将双声道音频数据转换为单声道（保持16位）
function convertStereoToMono(arrayBuffer) {
	const headerSize = 44; // WAV文件头大小
	const view = new DataView(arrayBuffer);
	const numChannels = 2; // 双声道
	const bitsPerSample = 16; // 16位

	// 计算单声道音频数据的长度
	const monoDataLength = ((view.byteLength - headerSize) / (numChannels * (bitsPerSample / 8))) * (bitsPerSample / 8);
	const monoBuffer = new ArrayBuffer(monoDataLength);
	const monoView = new DataView(monoBuffer);

	let monoIndex = 0;

	// 从双声道音频数据中提取一个声道的样本并写入单声道音频数据
	for (let i = headerSize; i < view.byteLength; i += (bitsPerSample / 8) * numChannels) {
		const leftSample = view.getInt16(i, true);
		const rightSample = view.getInt16(i + (bitsPerSample / 8), true);
		const monoSample = (leftSample + rightSample) / 2;
		monoView.setInt16(monoIndex, monoSample, true);
		monoIndex += (bitsPerSample / 8); // 每个样本占用2个字节
	}

	return monoBuffer;
}

// 3. 创建新的WAV文件头并将音频数据写入其中
function createMonoWavBlob(monoBuffer, header) {
	const monoDataLength = monoBuffer.byteLength;
	const totalLength = monoDataLength + 44; // 新的WAV文件总长度
	const newBuffer = new ArrayBuffer(totalLength);
	const newView = new DataView(newBuffer);

	// 写入WAV文件头
	newView.setUint8(0, 82); // 'R'
	newView.setUint8(1, 73); // 'I'
	newView.setUint8(2, 70); // 'F'
	newView.setUint8(3, 70); // 'F'

	// 写入文件长度（不包括前8个字节）
	newView.setUint32(4, totalLength - 8, true);

	// 写入WAVE标识
	newView.setUint8(8, 87); // 'W'
	newView.setUint8(9, 65); // 'A'
	newView.setUint8(10, 86); // 'V'
	newView.setUint8(11, 69); // 'E'

	// 写入"fmt "子块
	newView.setUint8(12, 102); // 'f'
	newView.setUint8(13, 109); // 'm'
	newView.setUint8(14, 116); // 't'
	newView.setUint8(15, 32); // 空格
	newView.setUint32(16, 16, true); // 子块大小
	newView.setUint16(20, 1, true); // 音频格式（PCM）
	newView.setUint16(22, 1, true); // 声道数（单声道）
	newView.setUint32(24, header.sampleRate, true); // 采样率
	newView.setUint32(28, header.byteRate, true); // 字节率
	newView.setUint16(32, header.blockAlign, true); // 块对齐
	newView.setUint16(34, header.bitsPerSample, true); // 每个样本的位数

	// 写入"data"标识和数据长度
	newView.setUint8(36, 100); // 'd'
	newView.setUint8(37, 97); // 'a'
	newView.setUint8(38, 116); // 't'
	newView.setUint8(39, 97); // 'a'
	newView.setUint32(40, monoDataLength, true); // 数据长度

	// 将音频数据写入新的WAV文件
	const monoDataView = new DataView(monoBuffer);
	for (let i = 0; i < monoDataLength; i++) {
		newView.setUint8(44 + i, monoDataView.getUint8(i));
	}

	// 创建Blob对象
	return new Blob([newView], { type: 'audio/wav' });
}

async function blobToArrayBuffer(blob) {
	return await blob.arrayBuffer();
}

async function convertAudioStereoToMono(audioBlob) {
	// 4. 使用上述函数进行转换
	const arrayBuffer = await blobToArrayBuffer(audioBlob);
	const header = parseWavHeader(arrayBuffer);
	const monoBuffer = convertStereoToMono(arrayBuffer);
	const monoWavBlob = createMonoWavBlob(monoBuffer, header);
	return monoWavBlob;
}

export default convertAudioStereoToMono;